import { Autocomplete, TextField, InputAdornment, Popper, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { MessageCasualIcon, MessageEmpatheticIcon, MessageFormalIcon, MessageFriendlyIcon, MessageImproveIcon, MessageImprovePurpleIcon, MessageLengthIon, MessageLengthPurpleIcon, MessagePlayfulIcon, MessageToneIcon, MessageTonePurpleIcon, MessageTranslateIcon, MessageTranslatePurpleIcon, RefineMessageActiveButtonicon, RefineMessageDisableButtonicon, RefineMessageUndoicon, SuggestedRepliesBoxCancelIcon } from "../../icon";
import AnimateLoaderComponent from "../shared/loaders/animate-loader.component";
import { useSelector } from "react-redux";
import * as selector from '../../selectors/selectors';
import falkonAiMessageGeneratingLoader from "../shared/loaders/falkon-ai-message-genearating-loader.json";
import { ChannelAiService } from "../../services/channels/ChannelAiService";


interface RefineFeature {
    Name: string;
    Active: boolean;
}

interface IProps {
    HandleAIfeaturesPopOver: () => void;
    SetBody: (body) => void;
    AiFeaturesRef: any;
    Body: string;
}

const ImproveMessage: React.FC<IProps> = (Props: IProps) => {

    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)

    const ToneOptions = [
        { name: "Formal", icon: <MessageFormalIcon className='w-2 h-2 mr-1' /> },
        { name: "Friendly", icon: <MessageFriendlyIcon className='w-2 h-2 mr-1' /> },
        { name: "Casual", icon: <MessageCasualIcon className='w-2 h-2 mr-1' /> },
        { name: "Playful", icon: <MessagePlayfulIcon className='w-2 h-2 mr-1' /> },
        { name: "Empathetic", icon: <MessageEmpatheticIcon className='w-2 h-2 mr-1' /> }
    ]

    const [falkonAiMessageRefineFeatures, setFalkonAiMessageRefineFeatures] = useState<RefineFeature[]>([
        { Name: "Improve", Active: false },
        // { Name: "Fix Spelling & Grammar", Active: false }
    ]);
    const [falkonAiMessageLength, setFalkonAiMessageLength] = useState<string>("");
    const [messageTone, setMessageTone] = useState<string>("");
    const [language, setLanguage] = useState<string>("");
    const [aiAnimation, setAiAnimation] = useState<boolean>(false);
    const [originalMessage, setOriginalMessage] = useState<string>("");

    const CustomPopper = (props) => {
        return <Popper {...props} placement="top" className='w-auto max-w-20 min-w-10' style={{ zIndex: 100000 }} />;
    };

    const handleResetAiFeatureSelection = () => {

        setFalkonAiMessageRefineFeatures([{ Name: "Improve", Active: false }])
        setMessageTone("Formal");
        setLanguage("English");
        setAiAnimation(false);

    }

    const handleMessageImprovement = () => {
        setAiAnimation(true)
        ChannelAiService.getImprovedMessage({
            message: Props.Body,
            length: falkonAiMessageLength,
            improve: falkonAiMessageRefineFeatures[0].Active,
            tone: messageTone,
            translate: language,
            channel: 6
        }).then((res) => {
            setOriginalMessage(Props.Body)
            Props.SetBody(res.data.refined_message)
            setAiAnimation(false)
            handleResetAiFeatureSelection();
        }).catch(() => {
            setAiAnimation(false);
            Props.HandleAIfeaturesPopOver();
        })
    }

    const handleResetOriginalMessage = () => {
        Props.SetBody(originalMessage)
    }

    return (
        <div className={`h-6 mx-auto suggested-reply-box bg-color-primary-background ${IsMobileDevice ? "br-5" : "br-3"} mb-1 bg-color-secondary`} style={{ bottom: Props.AiFeaturesRef.current.getBoundingClientRect().bottom + 52, left: Props.AiFeaturesRef.current.getBoundingClientRect().left, right: Props.AiFeaturesRef.current.getBoundingClientRect().right, top: Props.AiFeaturesRef.current.getBoundingClientRect().top - 52, width: Props.AiFeaturesRef.current.getBoundingClientRect().width }}>
            <div className='d-flex align-center w-p-100 h-p-100'>
                <div className={`br-4 ${!IsMobileDevice ? "ai-features-select-box px-1 footnote ml-2" : "mx-1 px-1 h5"} align-center justify-center d-flex min-h-4 c-pointer ${falkonAiMessageRefineFeatures[0].Active ? "bg-color-ai-primary-btn-box-shadow color-ai-primary-btn" : "color-text-field-font"}`} onClick={() => setFalkonAiMessageRefineFeatures([{ Name: "Improve", Active: !falkonAiMessageRefineFeatures[0].Active }])}>
                    {IsMobileDevice ? <MessageImprovePurpleIcon className='mr-1' /> : falkonAiMessageRefineFeatures[0].Active ? <MessageImprovePurpleIcon className='mr-1' style={{ color: "#caa1ff" }} /> : <MessageImproveIcon className='mr-1' />} Improve
                </div>
                <Autocomplete
                    className={`${IsMobileDevice ? "mr-1" : "min-w-13 ml-1"} br-4 b-none`}
                    value={messageTone}
                    disableClearable
                    onChange={(event, value) => setMessageTone(value)}
                    options={["Formal", "Friendly", "Casual", "Playful", "Empathetic"]}
                    getOptionLabel={(option) => option}
                    classes={{
                        input: `color-text-field-font ${IsMobileDevice ? "h5 w-p-40" : "footnote"} max-h-4 py-0 c-pointer`
                    }}
                    PopperComponent={IsMobileDevice ? CustomPopper : undefined}
                    renderOption={(props, option) => (
                        <li {...props}>
                            <div className={`${IsMobileDevice ? "h5" : "footnote"} d-flex align-center`}>
                                {ToneOptions.find(x => x.name === option).icon} {option}
                            </div>
                        </li>
                    )}
                    renderInput={(params) =>
                        <TextField
                            className=''
                            {...params}
                            placeholder="tone"
                            required
                            variant="standard"
                            size='small'
                            onKeyDown={(e) => e.preventDefault()}
                            inputProps={{ ...params.inputProps, readOnly: true }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                    <InputAdornment position="start">
                                        {IsMobileDevice ? <MessageTonePurpleIcon /> : <MessageToneIcon />}
                                    </InputAdornment>
                                ),
                                className: `${params.InputProps.className} br-4 ${IsMobileDevice ? "px-0" : "ai-features-select-box px-2"} align-center justify-center d-flex min-h-4`,
                            }}
                        />}
                />
                <Autocomplete
                    className={`${IsMobileDevice ? "mr-1" : "min-w-12 ml-1"} br-4 b-none`}
                    value={falkonAiMessageLength}
                    disableClearable
                    onChange={(e, value) => setFalkonAiMessageLength(value)}
                    options={["Shorten", "Expand"]}
                    getOptionLabel={(option) => option}
                    renderOption={(props, option) => (
                        <li {...props}>
                            <div className={`${IsMobileDevice ? "h5" : "footnote"} d-flex align-center`}>
                                {option}
                            </div>
                        </li>
                    )}
                    classes={{
                        input: `color-text-field-font ${IsMobileDevice ? "h5 w-p-40" : "footnote"} max-h-4 py-0 c-pointer`
                    }}
                    PopperComponent={IsMobileDevice ? CustomPopper : undefined}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            placeholder="length"
                            required
                            variant="standard"
                            size='small'
                            onKeyDown={(e) => e.preventDefault()}
                            inputProps={{ ...params.inputProps, readOnly: true }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                    <InputAdornment position="start">
                                        {IsMobileDevice ? <MessageLengthPurpleIcon /> : <MessageLengthIon />}
                                    </InputAdornment>
                                ),
                                className: `${params.InputProps.className} br-4 ${IsMobileDevice ? "px-0" : "ai-features-select-box px-2"} align-center justify-center d-flex min-h-4`,
                            }}
                        />}
                />
                <Autocomplete
                    className={`${IsMobileDevice ? "" : "min-w-12 ml-1"} br-4 b-none`}
                    value={language}
                    disableClearable
                    onChange={(event, value) => setLanguage(value)}
                    options={["Spanish", "French", "English"]}
                    getOptionLabel={(option) => option}
                    renderOption={(props, option) => (
                        <li {...props}>
                            <div className={`${IsMobileDevice ? "h5" : "footnote"} d-flex align-center`}>
                                {option}
                            </div>
                        </li>
                    )}
                    classes={{
                        input: `color-text-field-font ${IsMobileDevice ? "h5 w-p-50" : "footnote"} max-h-4 py-0 c-pointer`
                    }}
                    PopperComponent={IsMobileDevice ? CustomPopper : undefined}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            placeholder="translate"
                            variant="standard"
                            required
                            onKeyDown={(e) => e.preventDefault()}
                            inputProps={{ ...params.inputProps, readOnly: true }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                    <InputAdornment position="start">
                                        {IsMobileDevice ? <MessageTranslatePurpleIcon /> : <MessageTranslateIcon />}
                                    </InputAdornment>
                                ),
                                className: `${params.InputProps.className} br-4 ${IsMobileDevice ? "px-0" : "ai-features-select-box px-2"} align-center justify-center d-flex min-h-4`,
                            }}
                        />}
                />
                {aiAnimation ?
                    <AnimateLoaderComponent LoaderAnimation={falkonAiMessageGeneratingLoader} className={`${IsMobileDevice ? "max-w-7 d-flex align-center justify-center ml-auto" : "d-flex align-center justify-center max-w-7 mb-4 max-h-10  w-10 h-10 mt-4"}`} />
                    :
                    (Props.Body?.length && (falkonAiMessageRefineFeatures.find(x => x.Active) || !!falkonAiMessageLength.length || !!language.length || !!messageTone.length))
                        ?
                        <RefineMessageActiveButtonicon className={`${IsMobileDevice ? "min-w-4 ml-auto mr-1" : "min-w-4 c-pointer"}`} onClick={handleMessageImprovement} />
                        :
                        <RefineMessageDisableButtonicon className={`${IsMobileDevice ? "min-w-4 ml-auto mr-1" : "min-w-4"}`} />

                }
                {!IsMobileDevice &&
                    <div className='ml-auto d-flex align-center'>
                        {!!originalMessage.length &&
                            <Tooltip title='Undo Message' placement='top' className=''>
                                <RefineMessageUndoicon className='c-pointer' onClick={handleResetOriginalMessage} />
                            </Tooltip>
                        }
                        {<SuggestedRepliesBoxCancelIcon className='c-pointer' onClick={() => { Props.HandleAIfeaturesPopOver() }} />}
                    </div>
                }
            </div>
            {IsMobileDevice &&
                <div className='d-flex align-center p-relative justify-flex-end ml-auto w-20' style={{ bottom: 80, right: 0 }}>
                    {!!originalMessage.length &&
                        <Tooltip title='Undo Message' placement='top' className=''>
                            <RefineMessageUndoicon className='c-pointer' onClick={handleResetOriginalMessage} />
                        </Tooltip>
                    }
                    <SuggestedRepliesBoxCancelIcon className='c-pointer' onClick={() => { Props.HandleAIfeaturesPopOver(); }} />
                </div>
            }
        </div>
    )

}

export default ImproveMessage;